"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFeatureFlagsString = void 0;
const constants_1 = require("./constants");
const buildFeatureFlagsString = (featureFlags) => {
    const flags = Object.entries(featureFlags).map((nameAndValue) => nameAndValue.join(constants_1.NAME_VALUE_DELIMITER));
    return flags.join(constants_1.FLAG_DELIMITER);
};
exports.buildFeatureFlagsString = buildFeatureFlagsString;
